export default __webpack_public_path__ + "7cb382300e818a8729920b699e353780.svg";